export const formatNumberToCurrencyString = (
  number: number | null | undefined
) =>
  number
    ? new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(number)
    : "-";
